/* eslint-disable no-undef */
// from UserZoom (uzerzoom.com) -- see TP-357002: ALD User Feedback
_uzactfeed = window._uzactfeed || [];
_uzactfeed.push(['_setID', 'DDADDC0D447CEB11AA6BC03C136D6E1F']);
_uzactfeed.push(['_setSID', 'E0ABDC0D447CEB11AA6BC03C136D6E1F']);
_uzactfeed.push(['_start']);
(function () {
  var uz = document.createElement('script');
  uz.type = 'text/javascript';
  uz.async = true;
  uz.charset = 'utf-8';
  uz.src =
    ('https:' === document.location.protocol ? 'https://' : 'http://') +
    'cdn5.userzoom.com/feedback/js/uz_feed_us.js?cuid=50AC54FA6DCDE41180C90050569444FB';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(uz, s);
})();
